export const COLUMN_OPTIONS = (t, unitSettings) => {
  return {
    column1: {
      name: t("analysisColumn.date"),
      key: "date",
    },
    column5: {
      key: "column5",
      label: t("analysisColumn.flowrate", { unit: unitSettings.flow }),
      options: {
        option1Text: {
          unit: "flow",
          key: "feed_flowrate",
        },
        option2Text: {
          unit: "flow",
          key: "concentrate_flowrate",
        },
      },
    },
    column8: {
      key: "column8",
      label: t("analysisColumn.pressure", { unit: unitSettings.pressure }),
      options: {
        option1Text: {
          unit: "pressure",
          key: "pressure_drop",
        },
        option2Text: {
          unit: "pressure",
          key: "concentrate_pressure",
        },
      },
    },
    column9: {
      name: t("analysisColumn.feedQuality", {
        unit: unitSettings.feed_quality,
      }),
      unit: "feed_quality",
      key: "feed_quality",
    },
    column2: {
      name: t("analysisColumn.permeateflowrate", { unit: unitSettings.flow }),
      unit: "flow",
      key: "permeate_flowrate",
    },
    column7: {
      name: t("analysisColumn.feedPressure", { unit: unitSettings.pressure }),
      unit: "pressure",
      key: "feed_pressure",
    },
    column6: {
      name: t("analysisColumn.permeateQuality", {
        unit: unitSettings.permeate_quality,
      }),
      unit: "permeate_quality",
      key: "permeate_quality",
    },
    column3: {
      name: t("analysisColumn.feedTemperature", {
        unit: unitSettings.temperature,
      }),
      unit: "temperature",
      key: "feed_temp",
    },
    column4: {
      name: t("analysisColumn.permeatePressure", {
        unit: unitSettings.pressure,
      }),
      unit: "pressure",
      key: "permeate_pressure",
    },
  };
};

export const NORMALIZATION_COLUMN_OPTIONS = (t, unitSettings) => {
  return {
    column10: {
      name: t("analysisColumn.normalizedPermeateFlow", {
        unit: unitSettings.flow,
      }),
      unit: "flow",
      key: "norm_permeate_flow",
    },
    column11: {
      name: t("analysisColumn.normalizedPressureDrop", {
        unit: unitSettings.pressure,
      }),
      unit: "pressure",
      key: "norm_pressure_drop",
    },
    column12: {
      name: t("analysisColumn.normalizedSaltPassage"),
      key: "norm_salt_passage",
    },
  };
};

export const createArray = (number, key, create) => {
  let arr = [];
  if (create !== "") {
    if (key === "sel_stage") arr.push("All");
    if (number) {
      for (let i = 1; i <= number; i++) {
        arr.push(i.toString());
      }
    } else arr.push("1");
  }
  return arr;
};

export const TRAIN_OPTIONS = (t, config, selectedTrain, selectedPass) => {
  return {
    Pass: {
      name: t("analysisColumn.selectPass"),
      key: "sel_pass",
      options:
        selectedTrain !== ""
          ? createArray(
              config?.trains[selectedTrain].passes.length,
              "sel_pass",
              selectedTrain,
            )
          : [],
      isSelect: true,
    },

    Stage: {
      name: t("analysisColumn.selectStage"),
      key: "sel_stage",
      options:
        selectedPass !== ""
          ? createArray(
              config?.trains[selectedTrain].passes[selectedPass]?.stages.length,
              "sel_stage",
              selectedPass,
            )
          : [],
      isSelect: true,
    },
    pressureVessels: {
      name: t("addNewPlant.noPressureVessel"),
      key: "sel_pressure_vessels",
      isSelect: false,
    },
    elementsInvolved: {
      name: t("addNewPlant.noElementsInvolved"),
      key: "sel_element_involved",
      isSelect: false,
    },
    elementsType: {
      name: t("analysisColumn.element"),
      key: "sel_element_type",
      isSelect: false,
    },
  };
};

export const REFERENCE_CONDITION_OPTIONS = (t, selectedRadioColumn) => {
  return [
    // default to feedFlowrate
    {
      name:
        selectedRadioColumn?.column5 === "concentrate_flowrate"
          ? t("referenceConditions.concentrate_flowrate")
          : t("referenceConditions.feed_flowrate"),
      unit: "flow",
      key:
        selectedRadioColumn?.column5 === "concentrate_flowrate"
          ? "concentrate_flowrate"
          : "feed_flowrate",
      ranges: {
        hard: { min: 0.01, max: 10000 },
      },
      defaultUnit: "m³/h",
    },
    {
      name: t("referenceConditions.feed_pressure"),
      unit: "pressure",
      key: "feed_pressure",
      ranges: {
        hard: { min: 0.01, max: 80 },
      },
      defaultUnit: "bar",
    },
    {
      name: t("referenceConditions.feed_quality"),
      unit: "feed_quality",
      key: "feed_quality",
      ranges: {
        hard: { min: 0.01, max: 100000 },
      },
      defaultUnit: "µS/cm",
    },
    {
      name: t("referenceConditions.feed_temp"),
      unit: "temperature",
      key: "feed_temp",
      ranges: {
        hard: { min: 0.01, max: 45 },
      },
      defaultUnit: "°C",
    },
    {
      name: t("referenceConditions.permeate_flowrate"),
      unit: "flow",
      key: "permeate_flowrate",
      ranges: {
        hard: { min: 0.01, max: 10000 },
      },
      defaultUnit: "m³/h",
    },
    {
      name: t("referenceConditions.permeate_pressure"),
      unit: "pressure",
      key: "permeate_pressure",
      ranges: {
        hard: { min: 0.01, max: 5 },
      },
      defaultUnit: "bar",
    },
    {
      name: t("referenceConditions.permeate_quality"),
      unit: "permeate_quality",
      key: "permeate_quality",
      ranges: {
        hard: { min: 0.01, max: 10000 },
      },
      defaultUnit: "µS/cm",
    },
    {
      // default to concentrate_pressure
      name:
        selectedRadioColumn?.column8 === "pressure_drop"
          ? t("referenceConditions.pressure_drop")
          : t("referenceConditions.concentrate_pressure"),
      unit: "pressure",
      key:
        selectedRadioColumn?.column8 === "pressure_drop"
          ? "pressure_drop"
          : "concentrate_pressure",
      ranges: {
        hard: {
          min: 0.01,
          max: selectedRadioColumn?.column8 === "pressure_drop" ? 10 : 80,
        },
      },
      defaultUnit: "bar",
    },
  ];
};

export const REFERENCE_CONDITION_RELATIVE_COMPARISION = () => [
  // 0 index is main key(greater), 1 index is compare key(less)
  ["feed_flowrate", "concentrate_flowrate"],
  ["feed_flowrate", "permeate_flowrate"],
  ["feed_quality", "permeate_quality"],
  ["feed_pressure", "permeate_pressure"],
  ["feed_pressure", "concentrate_pressure"],
];
